<template>
  <div v-loading="loading" class="TestKitDetail" >
    <div class="TestKitDetail-form">
      <el-form ref="form" label-width="160px" :hide-required-asterisk="true" :rules="rules" :model="form" @submit.native.prevent size="small" >
        <div class="TestKitDetail-form-content">
          <template>
            <div class="TestKitDetail-form-content-list" v-for="(item,index) in form.questionList" :key="index" >
              <div class="TestKitDetail-form-content-list-title">
                {{ item.category }}
              </div>
              <template>
                <div v-for="(question,indexs) in item.questionList" :key="indexs" >

                  <!-- 类型3: 纯文本显示（标题） -->
                  <template v-if="question.isShow == '1' && question.type == 3" >
                    <div v-html="question.title" class="question-title-html"></div>
                  </template>

                  <!-- 类型0: 单选 -->
                  <template v-if="question.isShow == '1' && question.type == 0" >
                    <el-form-item
                        :label="question.title"
                        :prop="`questionList[${index}].questionList[${indexs}].value`"
                        :rules="question.necessary == 1 ? [{required: true, message: '请选择' + question.title, trigger: 'change'}] : []">
                      <el-radio-group v-model="question.value" @change="questionChange($event,question)" >
                        <el-radio v-for="answer in question.answerList" :key="answer.answerId" :label="answer.answerId">{{ answer.answerContent }}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </template>

                  <!-- 类型1: 多选 -->
                  <template v-if="question.isShow == '1' && question.type == 1" >
                    <el-form-item
                        :label="question.title"
                        :prop="`questionList[${index}].questionList[${indexs}].value`"
                        :rules="question.necessary == 1 ? [{required: true, message: '请选择' + question.title, trigger: 'change'}] : []">
                      <el-checkbox-group v-model="question.value" @change="questionChange($event,question)">
                        <el-checkbox
                            v-for="answer in question.answerList"
                            :key="answer.answerId"
                            :label="answer.answerId">
                          {{ answer.answerContent }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </template>

                  <!-- 类型2: 文本输入 -->
                  <template v-if="question.isShow == '1' && question.type == 2" >
                    <el-form-item
                        :label="question.title"
                        :prop="`questionList[${index}].questionList[${indexs}].value`"
                        :rules="question.necessary == 1 ? [{required: true, message: '请输入' + question.title, trigger: 'blur'}] : []">
                      <el-input v-model="question.value" clearable></el-input>
                    </el-form-item>
                  </template>

                  <!-- 类型7: 日期选择 -->
                  <template v-if="question.isShow == '1' && question.type == 7" >
                    <el-form-item
                        :label="question.title"
                        :prop="`questionList[${index}].questionList[${indexs}].value`"
                        :rules="question.necessary == 1 ? [{required: true, message: '请选择' + question.title, trigger: 'change'}] : []">
                      <el-date-picker
                          v-model="question.value"
                          type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          style="width: 100%">
                      </el-date-picker>
                    </el-form-item>
                  </template>

                  <!-- 类型8: 单选，选项内容为图片 -->
                  <template v-if="question.isShow == '1' && question.type == 8" >
                    <el-form-item
                        :label="question.title"
                        :prop="`questionList[${index}].questionList[${indexs}].value`"
                        :rules="question.necessary == 1 ? [{required: true, message: '请选择' + question.title, trigger: 'change'}] : []">
                      <el-radio-group class="radioGroupImageContainer" v-model="question.value" @change="questionChange($event,question)">
                        <div style="display: flex; flex-wrap: wrap; gap: 20px;">
                          <el-radio
                              v-for="answer in question.answerList"
                              :key="answer.answerId"
                              :label="answer.answerId"
                              style="display: flex; flex-direction: column; align-items: center;">
                            <div class="radioImageContainer" >
                              <img
                                  :src="getSrc(answer.answerImageUrl)"
                                  :alt="answer.answerContent"
                                  style="width: 100px; height: 100px; object-fit: contain; margin-bottom: 5px;">
                              <span>{{ answer.answerContent }}</span>
                            </div>
                          </el-radio>
                        </div>
                      </el-radio-group>
                    </el-form-item>
                  </template>

                  <!-- 类型9: 单选，选项带有备注信息 -->
                  <template v-if="question.isShow == '1' && question.type == 9" >
                    <el-form-item
                        :label="question.title"
                        :prop="`questionList[${index}].questionList[${indexs}].value`"
                        :rules="question.necessary == 1 ? [{required: true, message: '请选择' + question.title, trigger: 'change'}] : []">
                      <div style="width: 100%; display: flex; align-items: flex-end;">
                        <el-radio-group v-model="question.radioValue" @change="handleRadioWithRemarkChange($event, question)">
                          <el-radio
                              v-for="answer in question.answerList"
                              :key="answer.answerId"
                              :label="answer.answerId"
                              style="display: block; margin-bottom: 10px;">
                            {{ answer.answerContent }}
                          </el-radio>
                        </el-radio-group>

                        <!-- 备注输入框 -->
                        <el-input
                            v-if="showRemarkInput(question)"
                            v-model="question.remarkValue"
                            :placeholder="getRemarkHint(question)"
                            clearable
                            style="margin-top: 10px;margin-bottom: 5px; width: 300px;"
                            @input="updateRemarkValue(question)">
                        </el-input>
                      </div>
                    </el-form-item>
                  </template>

                  <!-- 类型10: 多选，选项带有备注信息 -->
                  <template v-if="question.isShow == '1' && question.type == 10" >
                    <el-form-item
                        :label="question.title"
                        :prop="`questionList[${index}].questionList[${indexs}].value`"
                        :rules="question.necessary == 1 ? [{required: true, message: '请选择' + question.title, trigger: 'change'}] : []">
                      <div style="width: 100%;">
                        <el-checkbox-group v-model="question.checkboxValues" @change="handleCheckboxWithRemarkChange($event, question)">
                          <div v-for="answer in question.answerList" :key="answer.answerId" style="margin-bottom: 10px;">
                            <el-checkbox :label="answer.answerId">
                              {{ answer.answerContent }}
                            </el-checkbox>

                            <!-- 多选的备注输入框 -->
                            <el-input
                                v-if="answer.isRemark == 1 && question.checkboxValues && question.checkboxValues.includes(answer.answerId)"
                                v-model="question.remarkValues[answer.answerId]"
                                :placeholder="answer.rmarkHint || '请输入备注'"
                                clearable
                                style="margin-left: 20px; width: 300px; margin-top: 5px;"
                                @input="updateMultiRemarkValue(answer.answerId, question)">
                            </el-input>
                          </div>
                        </el-checkbox-group>
                      </div>
                    </el-form-item>
                  </template>

                  <!-- 类型11: 时间选择框 -->
                  <template v-if="question.isShow == '1' && question.type == 11" >
                    <el-form-item
                        :label="question.title"
                        :prop="`questionList[${index}].questionList[${indexs}].value`"
                        :rules="question.necessary == 1 ? [{required: true, message: '请选择' + question.title, trigger: 'change'}] : []">
                      <el-time-select
                          v-model="question.value"
                          placeholder="选择时间"
                          :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '23:45',
                          format: 'HH:mm'
                        }"
                          style="width: 100%">
                      </el-time-select>
                    </el-form-item>
                  </template>

                  <!-- 类型12: 日期时间选择，没有秒 -->
                  <template v-if="question.isShow == '1' && question.type == 12" >
                    <el-form-item
                        :label="question.title"
                        :prop="`questionList[${index}].questionList[${indexs}].value`"
                        :rules="question.necessary == 1 ? [{required: true, message: '请选择' + question.title, trigger: 'change'}] : []">
                      <el-date-picker
                          v-model="question.value"
                          type="datetime"
                          placeholder="选择日期时间"
                          value-format="yyyy-MM-dd HH:mm"
                          format="yyyy-MM-dd HH:mm"
                          style="width: 100%">
                      </el-date-picker>
                    </el-form-item>
                  </template>

                </div>
              </template>
            </div>
          </template>
        </div>

        <el-form-item>
          <div class="TestKitDetail-form-button">
            <el-button @click="onsubmit" type="primary" native-type="submit">保存</el-button>
            <el-button @click="cancel">取消</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "zhongShanQuestionnaireDetail",
  data() {
    return {
      form: {
        questionList: []
      },
      rules: {},
      loading: false,
    }
  },
  computed: {
    getSrc() {
      return function (url) {
        return url ? `${process.env.VUE_APP_OSS_PATH}${url}` : "";
      }
    }
  },
  created() {
    this.getDetails();
  },
  methods: {
    async onsubmit() {
      try {
        const submitData = this.prepareSubmitData();
        console.log('提交数据:', submitData);
        const res = await this.$post("hh/polypInfo/add", {
          openId: this.$route.query.reagentId,
          questionAndAnswer:  submitData,
        })
        if (!res) return;
        this.$message.success("保存成功");
        this.cancel();
      }catch (e) {
        console.error(`保存失败: ${e}`);
      }
    },
    cancel() {
      this.$router.go(-1);
    },
    async getDetails() {
      this.loading = true;
      try {
        const res = await this.$get(`hh/polypInfo/findAllZsly?openId=${this.$route.query.reagentId}`);
        if (!res) return;
        const { data } = res;
        const keys = Object.keys(data);
        const currentKey = keys[0];

        this.form.questionList = data[currentKey].map((item) => {
          return {
            ...item,
            questionList: item.questionList.map((question) => {
              let value = "";
              let parsedValue = null;

              // 尝试解析value，如果已经是字符串化的JSON
              try {
                if (question.value && typeof question.value === 'string') {
                  // 处理可能的双重JSON字符串
                  let tempValue = question.value;
                  if (tempValue.startsWith('"') && tempValue.endsWith('"')) {
                    tempValue = tempValue.substring(1, tempValue.length - 1);
                  }
                  if (tempValue.startsWith('"') && tempValue.endsWith('"')) {
                    tempValue = tempValue.substring(1, tempValue.length - 1);
                  }
                  if (tempValue && (tempValue.startsWith('{') || tempValue.startsWith('['))) {
                    parsedValue = JSON.parse(tempValue);
                  } else {
                    parsedValue = tempValue;
                  }
                } else {
                  parsedValue = question.value;
                }
              } catch (e) {
                console.error('解析JSON失败:', question.value, e);
                parsedValue = question.value;
              }

              // 根据不同类型初始化数据
              switch (String(question.type)) {
                case "1": // 多选
                  if (Array.isArray(parsedValue)) {
                    value = parsedValue.map(item => {
                      if (typeof item === 'object' && item.answerId) {
                        return item.answerId;
                      }
                      return String(item).replace(/[^0-9]/g, '');
                    }).filter(id => id);
                  } else if (typeof parsedValue === 'string') {
                    value = parsedValue.split(',').map(v => v.trim()).filter(v => v);
                  } else {
                    value = [];
                  }
                  break;

                case "9": // 单选带备注
                  if (parsedValue && typeof parsedValue === 'object') {
                    value = {
                      value: parsedValue.value || '',
                      remark: parsedValue.remark || parsedValue.remarkContent || ''
                    };
                  } else if (typeof parsedValue === 'string') {
                    value = {
                      value: parsedValue,
                      remark: ''
                    };
                  } else {
                    value = {
                      value: '',
                      remark: ''
                    };
                  }
                  break;

                case "10": // 多选带备注
                  if (Array.isArray(parsedValue)) {
                    value = parsedValue.map(item => ({
                      answerId: item.answerId || String(item).replace(/[^0-9]/g, ''),
                      remarkContent: item.remarkContent || ''
                    })).filter(item => item.answerId);
                  } else if (typeof parsedValue === 'string') {
                    value = parsedValue.split(',').map(v => ({
                      answerId: v.trim(),
                      remarkContent: ''
                    })).filter(item => item.answerId);
                  } else {
                    value = [];
                  }
                  break;

                case "7": // 日期
                case "12": // 日期时间
                case "11": // 时间
                default: // 单选、文本等
                  if (typeof parsedValue === 'string') {
                    value = parsedValue.replace(/^"+|"+$/g, '');
                  } else {
                    value = parsedValue || '';
                  }
              }

              // 为不同类型添加额外的响应式属性
              const questionObj = {
                ...question,
                value
              };

              // 为带备注的题目添加额外的响应式属性
              if (question.type === 9) {
                questionObj.radioValue = value.value || '';
                questionObj.remarkValue = value.remark || '';
              } else if (question.type === 10) {
                questionObj.checkboxValues = value.map(item => item.answerId);
                questionObj.remarkValues = {};
                value.forEach(item => {
                  if (item.answerId) {
                    this.$set(questionObj.remarkValues, item.answerId, item.remarkContent || '');
                  }
                });
              }

              return questionObj;
            })
          };
        });

      } catch (e) {
        console.error(`获取详情失败`, e);
        this.$message.error('获取问卷详情失败');
      } finally {
        this.loading = false;
      }
    },

    // 处理带备注的单选变化
    handleRadioWithRemarkChange(value, question) {
      const selectedAnswer = question.answerList.find(answer => answer.answerId === value);
      question.radioValue = value;
      question.value = {
        value: value,
        remark: selectedAnswer && selectedAnswer.isRemark === 1 ? question.remarkValue : ''
      };
    },

    // 处理带备注的多选变化
    handleCheckboxWithRemarkChange(values, question) {
      question.checkboxValues = values || [];
      question.value = values.map(answerId => {
        const answer = question.answerList.find(a => a.answerId === answerId);
        return {
          answerId: answerId,
          remarkContent: answer && answer.isRemark === 1 ? (question.remarkValues[answerId] || '') : ''
        };
      });
    },

    // 更新单选备注
    updateRemarkValue(question) {
      if (question.radioValue) {
        question.value = {
          value: question.radioValue,
          remark: question.remarkValue || ''
        };
      }
    },

    // 更新多选备注
    updateMultiRemarkValue(answerId, question) {
      const index = question.value.findIndex(item => item.answerId === answerId);
      if (index > -1) {
        question.value[index].remarkContent = question.remarkValues[answerId] || '';
      } else {
        question.value.push({
          answerId: answerId,
          remarkContent: question.remarkValues[answerId] || ''
        });
      }
    },

    // 判断是否显示备注输入框（单选）
    showRemarkInput(question) {
      if (!question.radioValue) return false;
      const selectedAnswer = question.answerList.find(answer => answer.answerId === question.radioValue);
      return selectedAnswer && selectedAnswer.isRemark === 1;
    },

    // 获取备注提示
    getRemarkHint(question) {
      if (!question.radioValue) return '请输入备注';
      const selectedAnswer = question.answerList.find(answer => answer.answerId === question.radioValue);
      return selectedAnswer && selectedAnswer.rmarkHint ? selectedAnswer.rmarkHint : '请输入备注';
    },

    // 准备提交的数据
    prepareSubmitData() {
      const submitData = JSON.parse(JSON.stringify(this.form.questionList));

      submitData.forEach(category => {
        category.questionList.forEach(question => {
          // 根据不同类型处理数据格式
          switch (String(question.type)) {
            case "1": // 多选
              if (Array.isArray(question.value)) {
                question.value = JSON.stringify(question.value);
              }
              break;

            case "9": // 单选带备注
              if (question.value && typeof question.value === 'object') {
                question.value = JSON.stringify(question.value);
              }
              break;

            case "10": // 多选带备注
              if (Array.isArray(question.value)) {
                question.value = JSON.stringify(question.value);
              }
              break;

            case "7": // 日期
            case "12": // 日期时间
            case "11": // 时间
          }
        });
      });
      const questionList = (submitData[0].questionList || []).filter(item => item.type !== 3);
      return questionList.map(item => {
        return {
          answerId: "",
          questionContent: item.title,
          answerStr: item.value,
          questionId: item.questionId,
          childQuestionnaireResults: [],
        }
      });
    },

    // 通用的值变化处理
    questionChange(value, question) {
      console.log('问题变化:', question.questionId, value);
      // 这里可以添加其他的变化处理逻辑
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/TestKit/TestKitDetail";

:deep(.el-date-editor) {
  width: 200px!important;
}

.question-title-html {
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.image {
  width: 150px;
}
.radioGroupImageContainer{
  :deep(.el-radio__label){
    padding: 0;
  }
  .radioImageContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}


</style>
